export async function getPartnerUser(partner, token) {
  const baseURL = `https://clupp-api.web.app/v1/clupp/integrations/${partner}/user`;

  try {
    const response = await fetch(baseURL, {
      method: "POST",
      headers: {
        Origin: "clupp",
        Referer: "clupp",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token }),
    });

    if (!response.ok) {
      const errorMessage = `Error ${response.status}: ${response.statusText}`;
      throw new Error(errorMessage);
    }

    const json = await response.json();

    if (!json || (!json.data && !json.success)) {
      throw new Error("Error: Respuesta no válida del servidor");
    }

    return json.data || json;
  } catch (error) {
    console.error("Error al realizar la solicitud del afiliado:", error);
    return null;
  }
}
